/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* tslint:disable quotemark */
export default [
  "div[style=\"position: fixed; display: block; width: 100%; height: 100%; inset: 0px; background-color: rgba(0, 0, 0, 0); z-index: 300000;\"]",
  "acs, document.createElement, /l\\.parentNode\\.insertBefore\\(s/",
  ":not([style^=\"position: absolute; left: -5000px\"])",
  "acs, document.querySelectorAll, popMagic",
  "aost, String.prototype.charCodeAt, ai_",
  "aopr, app_vars.force_disable_adblock",
  "addEventListener, google_ad_client",
  "paid.outbrain.com/network/redir?\"]",
  "acs, document.addEventListener, ",
  "acs, document.getElementById, ",
  "acs, document.createElement, ",
  "aopr, document.dispatchEvent",
  "acs, String.fromCharCode, ",
  "nosiif, visibility, 1000",
  "set, blurred, false",
  "acs, eval, replace",
  "aeld, DOMContentLo",
  "decodeURIComponent",
  "[target=\"_blank\"]",
  "[href^=\"https://",
  "[href^=\"http://",
  "set, flashvars.",
  "#custom_html-",
  "BlockDetected",
  "no-fetch-if, ",
  "div[class^=\"",
  "dvertisement",
  "notification",
  "no-xhr-if, ",
  ", noopFunc",
  ":has-text(",
  "AaDetector",
  "aopw, _pop",
  "background",
  "horizontal",
  "nano-sib, ",
  "container",
  "Container",
  "decodeURI",
  "div[id^=\"",
  "div[style",
  "ompliance",
  "placehold",
  "rectangle",
  "[href*=\"",
  "#wpsafe-",
  "backdrop",
  "disclaim",
  "https://",
  "nextFunc",
  "nostif, ",
  "Notifica",
  "nowebrtc",
  "skyscrap",
  ".com/\"]",
  "300x250",
  "article",
  "consent",
  "content",
  "message",
  "Message",
  "privacy",
  "Privacy",
  "sidebar",
  "sponsor",
  "wrapper",
  "[class",
  "[data-",
  "728x90",
  "accept",
  "Accept",
  "aeld, ",
  "aopr, ",
  "aopw, ",
  "banner",
  "bottom",
  "cookie",
  "Cookie",
  "google",
  "notice",
  "nowoif",
  "policy",
  "Policy",
  "sticky",
  "widget",
  ":has(",
  ":not(",
  "acs, ",
  "block",
  "Block",
  "board",
  "click",
  "cript",
  "docum",
  "fixed",
  "frame",
  "modal",
  "popup",
  "sense",
  "set, ",
  "width",
  "Wrapp",
  "0px;",
  "body",
  "down",
  "foot",
  "gdpr",
  "html",
  "ight",
  "page",
  "show",
  "tion",
  "true",
  "www.",
  " > ",
  "box",
  "Box",
  "div",
  "ent",
  "ide",
  "img",
  "lay",
  "out",
  "sby",
  "top",
  "__",
  "--",
  ", ",
  ": ",
  ".a",
  ".j",
  ".m",
  ".t",
  "\"]",
  "=\"",
  "00",
  "ab",
  "ac",
  "ad",
  "Ad",
  "ag",
  "al",
  "am",
  "an",
  "ar",
  "at",
  "de",
  "e-",
  "ed",
  "el",
  "en",
  "er",
  "et",
  "fo",
  "g-",
  "he",
  "ic",
  "id",
  "il",
  "in",
  "is",
  "it",
  "la",
  "le",
  "lo",
  "o-",
  "od",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "ov",
  "p-",
  "ra",
  "re",
  "s_",
  "s-",
  "se",
  "si",
  "sp",
  "st",
  "t-",
  "te",
  "ti",
  "un",
  " ",
  "_",
  "-",
  ";",
  ":",
  ".",
  ")",
  "[",
  "]",
  "*",
  "/",
  "#",
  "^",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "A",
  "b",
  "B",
  "c",
  "C",
  "d",
  "D",
  "e",
  "E",
  "f",
  "F",
  "g",
  "h",
  "H",
  "i",
  "I",
  "j",
  "k",
  "l",
  "L",
  "m",
  "M",
  "n",
  "N",
  "o",
  "O",
  "p",
  "P",
  "q",
  "r",
  "R",
  "s",
  "S",
  "t",
  "T",
  "u",
  "U",
  "v",
  "w",
  "W",
  "x",
  "y",
  "z"
];